(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
      (function() {
        var stickyFilter = document.querySelector('[data-sticky-filter]');
        if (stickyFilter) {
          var lastScrollY = window.scrollY;
          var ticking = false;
          window.addEventListener('scroll', function() {
            if (!ticking) {
              requestAnimationFrame(function() {
                var currentScrollY = window.scrollY;
                if (stickyFilter.closest('[data-collection-layout="sticky"]') && window.matchMedia('(min-width: 1024px)').matches) {
                  lastScrollY = currentScrollY;
                  ticking = false;
                  return;
                }
                if (currentScrollY > lastScrollY && currentScrollY > 100) {
                  stickyFilter.style.top = '-' + (stickyFilter.offsetHeight + 20) + 'px';
                } else {
                  stickyFilter.style.top = '73px';
                }
                lastScrollY = currentScrollY;
                ticking = false;
              });
              ticking = true;
            }
          });
        }
      })();

      (function() {
        var viewToggleGroup = document.querySelector('[data-view-toggle-group]');
        var productGrid = document.querySelector('[data-product-grid]');

        if (!viewToggleGroup || !productGrid) return;

        var defaultCols = viewToggleGroup.dataset.defaultView || productGrid.dataset.mobileCols || '1';
        var storageKey = 'collection-mobile-view-cols';
        var storageDefaultKey = storageKey + '-default';

        function setView(cols) {
          productGrid.dataset.mobileCols = cols;
          viewToggleGroup.querySelectorAll('[data-view-cols]').forEach(function(btn) {
            btn.classList.toggle('active', btn.dataset.viewCols === cols);
          });
        }

        function persistView(cols) {
          try {
            localStorage.setItem(storageKey, cols);
            localStorage.setItem(storageDefaultKey, defaultCols);
          } catch(e) {}
        }

        var saved;
        var savedDefault;
        try {
          saved = localStorage.getItem(storageKey);
          savedDefault = localStorage.getItem(storageDefaultKey);
        } catch(e) {}

        if (saved && savedDefault === defaultCols) {
          setView(saved);
        } else {
          setView(defaultCols);
        }

        viewToggleGroup.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-view-cols]');
          if (btn) {
            setView(btn.dataset.viewCols);
            persistView(btn.dataset.viewCols);
          }
        });
      })();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm {
    constructor() {
      this.form = document.querySelector('#product-form');
      if (!this.form) return;
      
      this.variantData = this.getVariantData();
      this.currentVariant = this.getCurrentVariant();
      this.translations = JSON.parse(document.getElementById('product-translations').textContent);
      this.backInStockDialog = document.querySelector('[data-back-in-stock-dialog]');
      this.backInStockForm = document.querySelector('[data-back-in-stock-form]');
      
      this.setupEventListeners();
      this.initializeFromURL();
    }

    getVariantData() {
      const variantDataElement = document.getElementById('product-variant-data');
      if (variantDataElement) {
        return JSON.parse(variantDataElement.textContent);
      }
      
      return [];
    }

    getCurrentVariant() {
      const variantId = this.form.querySelector('[name="id"]').value;
      return this.variantData.find(v => v.id == variantId) || this.variantData[0];
    }

    setupEventListeners() {
      // Variant option changes
      this.form.querySelectorAll('[data-variant-option]').forEach(button => {
        button.addEventListener('click', this.handleVariantChange.bind(this));
      });

      // Quantity controls
      const quantityInput = this.form.querySelector('[data-quantity-input]');
      const decreaseBtn = this.form.querySelector('[data-quantity-decrease]');
      const increaseBtn = this.form.querySelector('[data-quantity-increase]');

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value) || 1;
          if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
          }
        });
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value) || 1;
          quantityInput.value = currentValue + 1;
        });
      }

      // Form submission
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      this.backInStockDialog?.querySelector('[data-back-in-stock-close]')?.addEventListener('click', () => {
        this.backInStockDialog.close();
      });

      this.backInStockForm?.addEventListener('submit', this.handleBackInStockSubmit.bind(this));
      
      // Initialize available options on page load
      this.initializeAvailableOptions();
    }

    initializeAvailableOptions() {
      // Get currently selected options
      const selectedOptions = [];
      this.form.querySelectorAll('[data-option-index]').forEach(group => {
        const activeButton = group.querySelector('[data-variant-option].bg-\\[\\#2C3F71\\]');
        if (activeButton) {
          selectedOptions[parseInt(activeButton.dataset.optionPosition) - 1] = activeButton.value;
        }
      });

      // Include fixed (hidden) options (e.g. hidden Color)
      this.form.querySelectorAll('.js-fixed-option').forEach(input => {
        const pos = parseInt(input.dataset.optionPosition);
        if (!Number.isNaN(pos)) {
          selectedOptions[pos - 1] = input.value;
        }
      });
      
      // Update available options based on current selection
      if (selectedOptions.length > 0) {
        this.updateAvailableOptions(selectedOptions);
      }
    }

    initializeFromURL() {
      // Check if there's a variant ID in the URL
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId) {
        const variant = this.variantData.find(v => v.id == variantId);
        if (variant) {
          // Update button states to match the URL variant
          this.form.querySelectorAll('[data-option-index]').forEach((group, index) => {
            const optionValue = variant[`option${index + 1}`];
            group.querySelectorAll('[data-variant-option]').forEach(btn => {
              if (btn.value === optionValue) {
                btn.classList.add('bg-[#2C3F71]', 'text-white');
                btn.classList.remove('bg-white');
                btn.setAttribute('aria-pressed', 'true');
              } else {
                btn.classList.remove('bg-[#2C3F71]', 'text-white');
                btn.classList.add('bg-white');
                btn.setAttribute('aria-pressed', 'false');
              }
            });
          });
          
          this.updateVariant(variant);
        }
      }
    }

    handleVariantChange(event) {
      const clickedButton = event.currentTarget;
      const clickedValue = clickedButton.value;
      const optionPosition = parseInt(clickedButton.dataset.optionPosition);

      // Update button states in the same option group
      const optionGroup = clickedButton.closest('[data-option-index]');
      optionGroup.querySelectorAll('[data-variant-option]').forEach(btn => {
        if (btn === clickedButton) {
          btn.classList.add('bg-[#2C3F71]', 'text-white');
          btn.classList.remove('bg-white');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('bg-[#2C3F71]', 'text-white');
          btn.classList.add('bg-white');
          btn.setAttribute('aria-pressed', 'false');
        }
      });

      // Get all currently selected option values
      const selectedOptions = [];
      this.form.querySelectorAll('[data-option-index]').forEach(group => {
        const activeButton = group.querySelector('[data-variant-option].bg-\\[\\#2C3F71\\]');
        if (activeButton) {
          selectedOptions[parseInt(activeButton.dataset.optionPosition) - 1] = activeButton.value;
        }
      });

      // Include fixed (hidden) options (e.g. hidden Color)
      this.form.querySelectorAll('.js-fixed-option').forEach(input => {
        const pos = parseInt(input.dataset.optionPosition);
        if (!Number.isNaN(pos)) {
          selectedOptions[pos - 1] = input.value;
        }
      });

      // Find matching variant
      const selectedVariant = this.variantData.find(variant => {
        return selectedOptions.every((option, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === option;
        });
      });

      if (selectedVariant) {
        this.updateVariant(selectedVariant);
        this.updateAvailableOptions(selectedOptions);
      }
    }

    updateAvailableOptions(currentSelections) {
      // Update which options should be enabled/disabled based on current selections
      this.form.querySelectorAll('[data-option-index]').forEach((group, groupIndex) => {
        // Use the actual option position from the buttons (supports hidden options)
        const firstButton = group.querySelector('[data-variant-option][data-option-position]');
        const optionPosition = firstButton ? parseInt(firstButton.dataset.optionPosition) : (groupIndex + 1);
        
        group.querySelectorAll('[data-variant-option]').forEach(button => {
          const testSelections = [...currentSelections];
          testSelections[optionPosition - 1] = button.value;
          
          const matchingVariant = this.variantData.find(variant => {
            return testSelections.every((option, index) => {
              if (!option) return true;
              return variant[`option${index + 1}`] === option;
            });
          });

          const hasAvailableVariant = Boolean(matchingVariant?.available);
          if (hasAvailableVariant) {
            button.classList.remove('opacity-50', 'cursor-not-allowed');
          } else {
            button.classList.add('opacity-50', 'cursor-not-allowed');
          }
        });
      });
    }

    updateVariant(variant) {
      this.currentVariant = variant;

      // Update hidden input
      this.form.querySelector('[name="id"]').value = variant.id;

      // Update compare at price and discount badges
      const compareElement = document.querySelector('[data-product-compare-price]');
      const imageDiscountBadge = document.querySelector('[data-image-discount-badge]');
      
      if (compareElement) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          
          compareElement.className = 'text-lg text-neutral-500 line-through font-secondary';
          
          // Update image discount badge (PDP carousel)
          if (imageDiscountBadge) {
            imageDiscountBadge.textContent = `-${discount}%`;
            imageDiscountBadge.classList.remove('hidden');
          }
        } else {
          compareElement.className = 'hidden';
          if (imageDiscountBadge) {
            imageDiscountBadge.classList.add('hidden');
          }
        }
      }

      // Update button state
      const addButton = this.form.querySelector('[data-add-to-cart]');
      const buttonText = addButton.querySelector('[data-button-text]');
      const backInStockIcon = addButton.querySelector('[data-back-in-stock-button-icon]');
      const translations = this.translations;

      addButton.disabled = !variant.available && !this.backInStockDialog;
      
      if (variant.available) {
        buttonText.textContent = translations.addToCart;
        backInStockIcon?.classList.add('hidden');
      } else {
        buttonText.textContent = this.backInStockDialog ? translations.backInStock : translations.soldOut;
        backInStockIcon?.classList.toggle('hidden', !this.backInStockDialog);
      }

      // Update URL
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Update stock status message
      const statusElement = document.querySelector('[data-product-status]');
      if (statusElement) {
        if (!variant.available) {
          statusElement.innerHTML = `<p class="text-sm text-neutral-600">${translations.soldOutMessage}</p>`;
        } else if (variant.inventory_management && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
          statusElement.innerHTML = `<p class="text-sm text-amber-600">${translations.lowStockMessage.replace('__COUNT__', variant.inventory_quantity)}</p>`;
        } else {
          statusElement.innerHTML = '';
        }
      }

      // Scroll to variant media if exists
      if (variant.featured_media) {
        const mediaElement = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (mediaElement) {
          mediaElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.currentVariant?.available) {
        this.openBackInStock(this.currentVariant?.id);
        return;
      }

      const addButton = this.form.querySelector('[data-add-to-cart]');
      const buttonText = addButton.querySelector('[data-button-text]');

      const formData = new FormData(this.form);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Network response was not ok');

        const data = await response.json();
        
        // Update cart count if element exists
        this.updateCartCount();
        window.dispatchEvent(new CustomEvent('cart-toggle', { detail: true }));


      } catch (error) {
        console.error('Error adding to cart:', error);
        
      }
    }

    openBackInStock(variantId) {
      if (!this.backInStockDialog || !variantId) return;

      const variant = this.variantData.find(item => String(item.id) === String(variantId));
      if (!variant || variant.available) return;

      const variantInput = this.backInStockDialog.querySelector('[data-back-in-stock-variant-id]');
      const variantLabel = this.backInStockDialog.querySelector('[data-back-in-stock-variant]');
      const status = this.backInStockDialog.querySelector('[data-back-in-stock-status]');

      variantInput.value = variant.id;
      variantLabel.textContent = variant.public_title || variant.title;
      status.textContent = '';
      status.classList.add('hidden');
      this.backInStockDialog.showModal();
      this.backInStockDialog.querySelector('[name="email"]')?.focus();
    }

    async handleBackInStockSubmit(event) {
      event.preventDefault();

      const submitButton = this.backInStockForm.querySelector('[data-back-in-stock-submit]');
      const submitText = this.backInStockForm.querySelector('[data-back-in-stock-submit-text]');
      const status = this.backInStockForm.querySelector('[data-back-in-stock-status]');
      const email = this.backInStockForm.elements.email.value.trim();
      const variantId = this.backInStockForm.elements.variant_id.value;
      const companyId = this.backInStockDialog.dataset.companyId;

      submitButton.disabled = true;
      submitText.textContent = this.translations.backInStockSubmitting;
      status.classList.add('hidden');

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) throw new Error('Back in stock subscription failed');

        this.backInStockForm.elements.email.value = '';
        status.textContent = this.translations.backInStockSuccess;
        status.classList.remove('hidden', 'text-red-700');
        status.classList.add('text-green-700');
      } catch (error) {
        status.textContent = this.translations.backInStockError;
        status.classList.remove('hidden', 'text-green-700');
        status.classList.add('text-red-700');
      } finally {
        submitButton.disabled = false;
        submitText.textContent = this.translations.backInStockSubmit;
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }

  // Product Carousel (Mobile & Desktop)
  class ProductCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.product-image-wrapper');
      
      // Featured slider properties
      this.featuredSlider = document.querySelector('[data-featured-slider]');
      this.featuredWrapper = document.querySelector('.featured-slider-wrapper');
      
      // Use featured slider children for slide count (works on mobile where thumbnails are hidden)
      this.mediaItems = this.featuredSlider ? Array.from(this.featuredSlider.children) : (this.track ? Array.from(this.track.children) : []);
      this.dots = Array.from(container.querySelectorAll('.carousel-dot'));
      this.currentIndex = 0;

      // Featured slider drag properties
      this.featuredStartX = 0;
      this.featuredCurrentX = 0;
      this.featuredStartIndex = 0;
      this.featuredIsDragging = false;
      this.featuredHasMoved = false;

      // Thumbnail strip properties
      this.thumbnailStartX = 0;
      this.thumbnailScrollStart = 0;
      this.thumbnailIsDragging = false;
      this.thumbnailMoved = false;

      this.init();
    }

    init() {
      this.setupEventListeners();
      this.initializeFeaturedImage();
    }

    initializeFeaturedImage() {
      // Initialize slider position to first slide
      if (this.featuredSlider) {
        this.featuredSlider.style.transform = 'translateX(0px)';
      }
      this.updateActiveDot(0);
    }

    setupEventListeners() {
      // Setup dot click handlers
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Setup media click handlers on featured slider (main images)
      this.mediaItems.forEach((media, index) => {
        media.addEventListener('click', (e) => {
          // Prevent click if we just dragged
          if (this.thumbnailMoved) {
            e.preventDefault();
            return;
          }
          this.goToSlide(index);
        });
      });

      // Setup click handlers on thumbnail strip (so clicking a thumbnail updates the main image)
      if (this.track) {
        this.track.querySelectorAll('[data-media-index]').forEach((el) => {
          el.addEventListener('click', (e) => {
            if (this.thumbnailMoved) {
              e.preventDefault();
              return;
            }
            const index = parseInt(el.dataset.mediaIndex, 10);
            if (!Number.isNaN(index)) {
              this.goToSlide(index);
            }
          });
        });
      }

      // Setup featured slider drag/swipe handlers
      if (this.featuredWrapper) {
        this.featuredWrapper.addEventListener('mousedown', this.handleFeaturedMouseDown.bind(this));
        this.featuredWrapper.addEventListener('mousemove', this.handleFeaturedMouseMove.bind(this));
        this.featuredWrapper.addEventListener('mouseup', this.handleFeaturedMouseEnd.bind(this));
        this.featuredWrapper.addEventListener('mouseleave', this.handleFeaturedMouseEnd.bind(this));

        this.featuredWrapper.addEventListener('touchstart', this.handleFeaturedTouchStart.bind(this), { passive: true });
        this.featuredWrapper.addEventListener('touchmove', this.handleFeaturedTouchMove.bind(this), { passive: false });
        this.featuredWrapper.addEventListener('touchend', this.handleFeaturedTouchEnd.bind(this));

        this.featuredWrapper.addEventListener('dragstart', (e) => e.preventDefault());
      }

      // Setup thumbnail strip drag handlers
      this.setupThumbnailDrag();

      // Setup lightbox handlers
      this.setupLightbox();
    }

    setupThumbnailDrag() {
      if (!this.track) return;
      
      // Only enable drag on desktop when there are more than 5 items
      const visibleCount = parseInt(this.container.dataset.visibleCount || this.track.dataset.visibleCount);
      if (visibleCount <= 5) return;

      // Prevent default drag behavior on images
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
      
      this.track.addEventListener('mousedown', this.handleThumbnailMouseDown.bind(this));
      this.track.addEventListener('mousemove', this.handleThumbnailMouseMove.bind(this));
      this.track.addEventListener('mouseup', this.handleThumbnailMouseEnd.bind(this));
      this.track.addEventListener('mouseleave', this.handleThumbnailMouseEnd.bind(this));

      this.track.addEventListener('touchstart', this.handleThumbnailTouchStart.bind(this), { passive: true });
      this.track.addEventListener('touchmove', this.handleThumbnailTouchMove.bind(this), { passive: false });
      this.track.addEventListener('touchend', this.handleThumbnailTouchEnd.bind(this));

      this.track.style.cursor = 'grab';
    }

    handleThumbnailMouseDown(e) {
      this.thumbnailIsDragging = true;
      this.thumbnailMoved = false;
      this.thumbnailStartX = e.pageX;
      this.thumbnailScrollStart = this.track.scrollLeft;
      this.track.style.cursor = 'grabbing';
      e.preventDefault();
    }

    handleThumbnailMouseMove(e) {
      if (!this.thumbnailIsDragging) return;
      e.preventDefault();
      
      const deltaX = e.pageX - this.thumbnailStartX;
      
      // Mark as moved if we've dragged more than 5px
      if (Math.abs(deltaX) > 5) {
        this.thumbnailMoved = true;
      }
      
      this.track.scrollLeft = this.thumbnailScrollStart - deltaX;
    }

    handleThumbnailMouseEnd(e) {
      if (!this.thumbnailIsDragging) return;
      this.thumbnailIsDragging = false;
      this.track.style.cursor = 'grab';
      
      // Reset moved flag after a short delay
      setTimeout(() => {
        this.thumbnailMoved = false;
      }, 50);
    }

    handleThumbnailTouchStart(e) {
      this.thumbnailIsDragging = true;
      this.thumbnailStartX = e.touches[0].pageX;
      this.thumbnailScrollStart = this.track.scrollLeft;
    }

    handleThumbnailTouchMove(e) {
      if (!this.thumbnailIsDragging) return;
      
      const deltaX = e.touches[0].pageX - this.thumbnailStartX;
      this.track.scrollLeft = this.thumbnailScrollStart - deltaX;
      
      if (Math.abs(deltaX) > 10) {
        e.preventDefault();
      }
    }

    handleThumbnailTouchEnd(e) {
      this.thumbnailIsDragging = false;
    }

    setupLightbox() {
      const lightboxModal = document.querySelector('[data-lightbox-modal]');
      const lightboxImage = document.querySelector('[data-lightbox-image]');
      const lightboxVideo = document.querySelector('[data-lightbox-video]');
      const lightboxCounter = document.querySelector('[data-lightbox-counter]');
      const lightboxClose = document.querySelector('[data-lightbox-close]');
      const lightboxPrev = document.querySelector('[data-lightbox-prev]');
      const lightboxNext = document.querySelector('[data-lightbox-next]');

      if (!lightboxModal) return;

      let currentLightboxIndex = 0;
      // Include both images and videos in lightbox
      const allMedia = this.mediaItems;

      // Click handlers for featured images only (not videos in featured slider)
      const featuredImages = document.querySelectorAll('[data-featured-media][data-lightbox-trigger]');
      featuredImages.forEach((img, index) => {
        // Only add lightbox trigger to images in featured slider, not videos
        if (img.tagName === 'IMG') {
          img.addEventListener('click', (e) => {
            if (this.featuredHasMoved) {
              this.featuredHasMoved = false;
              return;
            }
            
            const mediaIndex = parseInt(img.dataset.mediaIndex);
            const lightboxIndex = allMedia.findIndex(item => parseInt(item.dataset.mediaIndex) === mediaIndex);
            
            if (lightboxIndex !== -1) {
              currentLightboxIndex = lightboxIndex;
              openLightbox(lightboxIndex);
            }
          });
        }
      });

      // Click handlers for video in featured slider
      const featuredVideos = document.querySelectorAll('[data-featured-slider] [data-featured-media][data-media-type="video"]');
      featuredVideos.forEach((videoContainer) => {
        videoContainer.addEventListener('click', (e) => {
          if (this.featuredHasMoved) {
            this.featuredHasMoved = false;
            return;
          }
          
          const mediaIndex = parseInt(videoContainer.dataset.mediaIndex);
          const lightboxIndex = allMedia.findIndex(item => parseInt(item.dataset.mediaIndex) === mediaIndex);
          
          if (lightboxIndex !== -1) {
            currentLightboxIndex = lightboxIndex;
            openLightbox(lightboxIndex);
          }
        });
      });

      const openLightbox = (index) => {
        const mediaItem = allMedia[index];
        if (!mediaItem) return;

        // Featured slider images are plain <img> without data-media-type; thumbnail strip has data attributes
        const isImage = mediaItem.tagName === 'IMG' || mediaItem.dataset.mediaType === 'image';
        const isVideo = mediaItem.dataset.mediaType === 'video' || mediaItem.querySelector('video, iframe');

        // Pause all videos including featured slider
        this.pauseAllVideos();

        // Clear previous video content
        lightboxVideo.innerHTML = '';
        
        if (isImage) {
          // Prefer high-res from thumbnail strip; fall back to featured image src
          const thumbItem = this.track ? this.track.querySelector(`[data-media-index="${index}"]`) : null;
          const imageSrc = (thumbItem && (thumbItem.dataset.featuredSrc || thumbItem.dataset.imageSrc))
            || mediaItem.currentSrc
            || mediaItem.src;
          lightboxImage.src = imageSrc;
          lightboxImage.alt = mediaItem.alt || '';
          lightboxImage.classList.remove('hidden');
          lightboxVideo.classList.add('hidden');
        } else if (isVideo) {
          // Show video, hide image
          lightboxImage.classList.add('hidden');
          lightboxVideo.classList.remove('hidden');

          // Prefer thumbnail strip's hidden desktop video; fall back to featured slider's video/iframe
          let videoSource = mediaItem.querySelector('[data-video-html-desktop]');
          if (!videoSource && this.track) {
            const thumbItem = this.track.querySelector(`[data-media-index="${index}"]`);
            if (thumbItem) videoSource = thumbItem.querySelector('[data-video-html-desktop]');
          }
          if (!videoSource) {
            videoSource = mediaItem.querySelector('video, iframe')?.closest('div') || mediaItem;
          }
          if (videoSource) {
            const videoClone = videoSource.cloneNode(true);
            videoClone.classList.remove('hidden');
            const video = videoClone.querySelector('video');
            const iframe = videoClone.querySelector('iframe');
            if (video) {
              video.controls = false;
              video.autoplay = true;
              video.muted = true;
              video.loop = true;
              video.style.maxWidth = '90vw';
              video.style.maxHeight = '90vh';
              video.style.width = 'auto';
              video.style.height = 'auto';
              video.style.objectFit = 'contain';
              video.play();
            }
            if (iframe) {
              iframe.style.maxWidth = '90vw';
              iframe.style.maxHeight = '90vh';
            }
            lightboxVideo.appendChild(videoClone);
          }
        }

        lightboxCounter.textContent = `${index + 1} / ${allMedia.length}`;
        lightboxModal.classList.remove('hidden');
        lightboxModal.classList.add('flex');
        document.body.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        // Pause lightbox video
        const video = lightboxVideo.querySelector('video');
        if (video) {
          video.pause();
        }
        
        lightboxModal.classList.add('hidden');
        lightboxModal.classList.remove('flex');
        document.body.style.overflow = '';
      };

      const showPrevMedia = () => {
        currentLightboxIndex = (currentLightboxIndex - 1 + allMedia.length) % allMedia.length;
        openLightbox(currentLightboxIndex);
      };

      const showNextMedia = () => {
        currentLightboxIndex = (currentLightboxIndex + 1) % allMedia.length;
        openLightbox(currentLightboxIndex);
      };

      // Event listeners
      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrev?.addEventListener('click', showPrevMedia);
      lightboxNext?.addEventListener('click', showNextMedia);
      lightboxModal?.addEventListener('click', (e) => {
        if (e.target === lightboxModal) closeLightbox();
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!lightboxModal.classList.contains('flex')) return;
        
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') showPrevMedia();
        if (e.key === 'ArrowRight') showNextMedia();
      });
    }

    handleFeaturedMouseDown(e) {
      this.featuredIsDragging = true;
      this.featuredHasMoved = false;
      this.featuredStartX = e.pageX;
      
      // Get current transform value
      const transform = this.featuredSlider.style.transform;
      const match = transform.match(/translateX\((-?\d+)px\)/);
      this.featuredCurrentX = match ? parseInt(match[1]) : 0;
      
      // Calculate and store the starting slide index
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const gapWidth = 8;
      const slideWithGap = slideWidth + gapWidth;
      this.featuredStartIndex = Math.round(Math.abs(this.featuredCurrentX) / slideWithGap);
      
      this.featuredWrapper.style.cursor = 'grabbing';
      // Disable transition during drag
      this.featuredSlider.style.transition = 'none';
    }

    handleFeaturedMouseMove(e) {
      if (!this.featuredIsDragging) return;
      e.preventDefault();
      this.featuredHasMoved = true;
      
      const deltaX = e.pageX - this.featuredStartX;
      const newX = this.featuredCurrentX + deltaX;
      
      // Apply boundaries (don't slide past first or last item)
      const maxX = 0;
      const gapWidth = 8; // 8px gap (gap-2 = 0.5rem = 8px)
      // Get slide width from wrapper (each slide is w-full = 100% of wrapper)
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const minX = -((this.mediaItems.length - 1) * (slideWidth + gapWidth));
      const boundedX = Math.max(minX, Math.min(maxX, newX));
      
      this.featuredSlider.style.transform = `translateX(${boundedX}px)`;
    }

    handleFeaturedMouseEnd(e) {
      if (!this.featuredIsDragging) return;
      this.featuredIsDragging = false;
      this.featuredWrapper.style.cursor = 'grab';
      
      if (this.featuredHasMoved) {
        // Get slide width from wrapper (each slide is w-full = 100% of wrapper)
        const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
        const gapWidth = 8; // 8px gap (gap-2 = 0.5rem = 8px)
        const slideWithGap = slideWidth + gapWidth;
        
        // Calculate swipe distance
        const deltaX = e.pageX - this.featuredStartX;
        
        // Use the starting index as the base
        const startIndex = this.featuredStartIndex || 0;
        
        // Determine target index based on swipe direction and distance
        // Use 20% threshold - if swiped more than 20% of slide width, change slides
        const threshold = slideWidth * 0.2;
        let targetIndex = startIndex;
        
        if (Math.abs(deltaX) > threshold) {
          if (deltaX > 0) {
            // Swiped right - go to previous slide
            targetIndex = startIndex - 1;
          } else {
            // Swiped left - go to next slide
            targetIndex = startIndex + 1;
          }
        }
        
        // Ensure target index is within bounds
        targetIndex = Math.max(0, Math.min(this.mediaItems.length - 1, targetIndex));
        const targetX = -targetIndex * slideWithGap;
        
        // Use requestAnimationFrame to ensure smooth transition
        requestAnimationFrame(() => {
          // Re-enable transition with explicit values
          this.featuredSlider.style.transition = 'transform 0.3s ease-in-out';
          
          // Set the target transform
          this.featuredSlider.style.transform = `translateX(${targetX}px)`;
          
          // Update dot indicator
          this.updateActiveDot(targetIndex);
          
          // Reset the moved flag after transition completes
          setTimeout(() => {
            this.featuredHasMoved = false;
          }, 300);
          
          // Pause all videos and play the active one if it's a video
          this.pauseAllVideos();
          setTimeout(() => {
            const targetMedia = this.featuredSlider.children[targetIndex];
            if (targetMedia) {
              const video = targetMedia.querySelector('video');
              if (video) {
                video.currentTime = 0;
                video.play().catch(err => console.log('Featured video play failed:', err));
              }
            }
          }, 300);
        });
      } else {
        // No movement, just re-enable transition
        this.featuredSlider.style.transition = 'transform 0.3s ease-in-out';
        this.featuredHasMoved = false;
      }
    }

    handleFeaturedTouchStart(e) {
      this.featuredIsDragging = true;
      this.featuredHasMoved = false;
      this.featuredStartX = e.touches[0].pageX;
      
      // Get current transform value
      const transform = this.featuredSlider.style.transform;
      const match = transform.match(/translateX\((-?\d+)px\)/);
      this.featuredCurrentX = match ? parseInt(match[1]) : 0;
      
      // Calculate and store the starting slide index
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const gapWidth = 8;
      const slideWithGap = slideWidth + gapWidth;
      this.featuredStartIndex = Math.round(Math.abs(this.featuredCurrentX) / slideWithGap);
      
      // Disable transition during drag
      this.featuredSlider.style.transition = 'none';
    }

    handleFeaturedTouchMove(e) {
      if (!this.featuredIsDragging) return;
      this.featuredHasMoved = true;
      
      const deltaX = e.touches[0].pageX - this.featuredStartX;
      const newX = this.featuredCurrentX + deltaX;
      
      // Apply boundaries
      const maxX = 0;
      const gapWidth = 8; // 8px gap (gap-2 = 0.5rem = 8px)
      // Get slide width from wrapper (each slide is w-full = 100% of wrapper)
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const minX = -((this.mediaItems.length - 1) * (slideWidth + gapWidth));
      const boundedX = Math.max(minX, Math.min(maxX, newX));
      
      this.featuredSlider.style.transform = `translateX(${boundedX}px)`;
      
      if (Math.abs(deltaX) > 10) {
        e.preventDefault();
      }
    }

    handleFeaturedTouchEnd(e) {
      if (!this.featuredIsDragging) return;
      
      // Get slide width from wrapper (each slide is w-full = 100% of wrapper)
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const gapWidth = 8; // 8px gap (gap-2 = 0.5rem = 8px)
      const slideWithGap = slideWidth + gapWidth;
      
      // Calculate swipe distance and direction from touch start to end
      const endX = e.changedTouches?.[0]?.pageX || 0;
      const deltaX = endX - this.featuredStartX;
      
      this.featuredIsDragging = false;
      
      if (this.featuredHasMoved) {
        // Use the starting index as the base
        const startIndex = this.featuredStartIndex || 0;
        
        // Determine target index based on swipe direction and distance
        // Use 20% threshold - if swiped more than 20% of slide width, change slides
        const threshold = slideWidth * 0.2;
        let targetIndex = startIndex;
        
        if (Math.abs(deltaX) > threshold) {
          if (deltaX > 0) {
            // Swiped right - go to previous slide
            targetIndex = startIndex - 1;
          } else {
            // Swiped left - go to next slide
            targetIndex = startIndex + 1;
          }
        }
        
        // Ensure target index is within bounds
        targetIndex = Math.max(0, Math.min(this.mediaItems.length - 1, targetIndex));
        const targetX = -targetIndex * slideWithGap;
        
        // Use requestAnimationFrame to ensure smooth transition
        requestAnimationFrame(() => {
          // Re-enable transition with explicit values
          this.featuredSlider.style.transition = 'transform 0.3s ease-in-out';
          
          // Set the target transform
          this.featuredSlider.style.transform = `translateX(${targetX}px)`;
          
          // Update dot indicator
          this.updateActiveDot(targetIndex);
          
          // Reset the moved flag after transition completes
          setTimeout(() => {
            this.featuredHasMoved = false;
          }, 300);
          
          // Pause all videos and play the active one if it's a video
          this.pauseAllVideos();
          setTimeout(() => {
            const targetMedia = this.featuredSlider.children[targetIndex];
            if (targetMedia) {
              const video = targetMedia.querySelector('video');
              if (video) {
                video.currentTime = 0;
                video.play().catch(err => console.log('Featured video play failed:', err));
              }
            }
          }, 300);
        });
      } else {
        // No movement, just re-enable transition
        this.featuredSlider.style.transition = 'transform 0.3s ease-in-out';
        this.featuredHasMoved = false;
      }
    }

    goToSlide(index) {
      if (!this.featuredSlider) return;
      
      // Pause all videos before sliding
      this.pauseAllVideos();
      
      // Calculate and apply transform
      // Get slide width from wrapper (each slide is w-full = 100% of wrapper)
      const slideWidth = this.featuredWrapper ? this.featuredWrapper.offsetWidth : (this.featuredSlider.children[0]?.offsetWidth || 0);
      const gapWidth = 8; // 8px gap (gap-2 = 0.5rem = 8px)
      const targetPosition = index * (slideWidth + gapWidth);
      this.featuredSlider.style.transform = `translateX(-${targetPosition}px)`;
      
      // Update dot indicator
      this.updateActiveDot(index);
      
      // Play video if target is a video
      setTimeout(() => {
        const targetMedia = this.featuredSlider.children[index];
        if (targetMedia) {
          const video = targetMedia.querySelector('video');
          if (video) {
            video.currentTime = 0;
            video.play().catch(err => console.log('Featured video play failed:', err));
          }
        }
      }, 300);
    }

    updateActiveDot(index) {
      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.remove('bg-[#B99D74]', 'opacity-[0.3]');
          dot.classList.add('bg-[#2C3F71]');
          dot.classList.remove('opacity-[0.3]');
        } else {
          dot.classList.remove('bg-[#2C3F71]');
          dot.classList.add('bg-[#B99D74]', 'opacity-[0.3]');
        }
      });
    }

    pauseAllVideos() {
      // Pause all videos in the gallery
      const allVideos = this.container.querySelectorAll('video');
      allVideos.forEach(video => {
        video.pause();
      });
    }

  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductForm();
      const gallery = document.querySelector('.product-gallery');
      if (gallery) new ProductCarousel(gallery);
    });
  } else {
    new ProductForm();
    const gallery = document.querySelector('.product-gallery');
    if (gallery) new ProductCarousel(gallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    var viewToggleGroup = document.querySelector('[data-view-toggle-group]');
    var productGrid = document.querySelector('[data-product-grid]');

    if (viewToggleGroup && productGrid) {
      var defaultCols = viewToggleGroup.dataset.defaultView || productGrid.dataset.mobileCols || '1';
      var storageKey = 'search-mobile-view-cols';
      var storageDefaultKey = storageKey + '-default';

      function setView(cols) {
        productGrid.dataset.mobileCols = cols;
        viewToggleGroup.querySelectorAll('[data-view-cols]').forEach(function(btn) {
          btn.classList.toggle('active', btn.dataset.viewCols === cols);
        });
      }

      function persistView(cols) {
        try {
          localStorage.setItem(storageKey, cols);
          localStorage.setItem(storageDefaultKey, defaultCols);
        } catch(e) {}
      }

      var saved;
      var savedDefault;
      try {
        saved = localStorage.getItem(storageKey);
        savedDefault = localStorage.getItem(storageDefaultKey);
      } catch(e) {}

      if (saved && savedDefault === defaultCols) {
        setView(saved);
      } else {
        setView(defaultCols);
      }

      viewToggleGroup.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-view-cols]');
        if (btn) {
          setView(btn.dataset.viewCols);
          persistView(btn.dataset.viewCols);
        }
      });
    }

    var stickyFilter = document.querySelector('[data-sticky-filter]');
    if (stickyFilter) {
      var lastScrollY = window.scrollY;
      var ticking = false;
      window.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(function() {
            var currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 100) {
              stickyFilter.style.top = '-' + (stickyFilter.offsetHeight + 20) + 'px';
            } else {
              stickyFilter.style.top = '73px';
            }
            lastScrollY = currentScrollY;
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  const carousel = document.querySelector('.topbar-carousel');
  const items = carousel.querySelectorAll('.topbar-item');
  
  if (items.length > 1) {
    // Clone items for infinite loop
    items.forEach(item => {
      const clone = item.cloneNode(true);
      carousel.appendChild(clone);
    });

    let currentIndex = 0;
    const totalItems = items.length;
    const itemWidth = items[0].offsetWidth;

    function slide() {
      currentIndex++;
      carousel.classList.add('transitioning');
      carousel.style.transform = `translateX(-${currentIndex * itemWidth}px)`;

      if (currentIndex >= totalItems) {
        setTimeout(() => {
          carousel.classList.remove('transitioning');
          carousel.classList.add('resetting');
          currentIndex = 0;
          carousel.style.transform = 'translateX(0)';
          
          setTimeout(() => {
            carousel.classList.remove('resetting');
          }, 50);
        }, 500);
      }
    }

    setInterval(slide, 4000);
  }

  } catch(e) { console.error(e); }
})();
})();
